"use client";
import { FC, useCallback, useState } from "react";
import { handleRedirection } from "../../utils/helper";
import { StockContent } from "./StockContent";
import { StockCardProps } from "./types";
import { useRouter } from "next/navigation";

export const StockInfoCard: FC<StockCardProps> = ({
  stock,
  defaultImage,
  fullWidth = false,
  modalTitle,
  modalBtnCta,
  successMsg,
  errorMsg,
  onCardClick,
  section_title,
  cta_text
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const router = useRouter()

  const handleCardClick = useCallback(
    (e: React.MouseEvent) => {
      onCardClick?.(stock);
      if (isModalOpen) {
        return;
      }

      const target = e.target as HTMLElement;
      if (
        target.closest('button[aria-label="Add to watchlist"]') ||
        target.closest(".icomoon")
      ) {
        return;
      }
      handleRedirection(`/${stock.redirectURL}`,router);
    },
    [stock.redirectURL, isModalOpen],
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (isModalOpen) {
        return;
      }

      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleRedirection(`/${stock.redirectURL}`);
      }
    },
    [stock.redirectURL, isModalOpen],
  );

  return (
    <div
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`View details for ${stock.fullName || stock.symbol || "stock"}`}
    >
      <div
        className={`w-items-start inline-flex min-h-[145px] justify-start rounded-[8px] border border-[#e5e5e5] bg-white p-3 md:min-h-[169px] ${fullWidth ? "w-full" : "w-[214px]"}`}
      >
        <div className="w-full">
          <div className="flex flex-col">
            <StockContent
              stock={stock}
              defaultImage={defaultImage}
              onModalStateChange={setIsModalOpen}
              modalTitle={modalTitle}
              modalBtnCta={modalBtnCta}
              successMsg={successMsg}
              errorMsg={errorMsg}
              cta_text={cta_text}
              section_title={section_title}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockInfoCard;
